import { RadioButtonField, SelectIdField } from '~fields';

const PrecautionFields = props => (
  <>
    <RadioButtonField name="precautions" flat firstElementMinWidth="150px" />

    {props.formik.values.precautions === 'YES' && (
      <SelectIdField
        name="precautionClass"
        required
        instruction="HUOM! Valitse kriittisin eristysluokka"
      />
    )}
  </>
);

export default PrecautionFields;
